export function getIsLoggedIn(authState) {
  if (authState === undefined) {
    return false;
  }

  return !(authState === 'ANONYMOUS' || authState === 'IDENTIFIED');
}

export function getHeaderProps(authState, data) {
  const isLoggedIn = getIsLoggedIn(authState);

  return {
    config: data.config,
    content: isLoggedIn ? data.contentLoggedIn : data.contentLoggedOut,
  };
}

export function getHeaderClassName(version) {
  /**
   * Marketing header redesign (v3) is higher than the previous version
   * and works only for en_US so far
   */
  return version === 'v3'
    ? 'marketing-header-background-v3'
    : 'marketing-header-background';
}
